import { render, staticRenderFns } from "./FolioTable.vue?vue&type=template&id=eb043f74&scoped=true&"
import script from "./FolioTable.vue?vue&type=script&lang=js&"
export * from "./FolioTable.vue?vue&type=script&lang=js&"
import style0 from "./FolioTable.vue?vue&type=style&index=0&id=eb043f74&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb043f74",
  null
  
)

export default component.exports